import _classCallCheck from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Volume } from "../component/channel/Volume";
import { ToneAudioNode } from "../core/context/ToneAudioNode";
import { optionsFromArguments } from "../core/util/Defaults";
import { readOnly } from "../core/util/Interface";
/**
 * Base-class for all instruments
 */

export var Instrument = /*#__PURE__*/function (_ToneAudioNode) {
  _inherits(Instrument, _ToneAudioNode);

  var _super = _createSuper(Instrument);

  function Instrument() {
    var _this;

    _classCallCheck(this, Instrument);

    _this = _super.call(this, optionsFromArguments(Instrument.getDefaults(), arguments));
    /**
     * Keep track of all events scheduled to the transport
     * when the instrument is 'synced'
     */

    _this._scheduledEvents = [];
    /**
     * If the instrument is currently synced
     */

    _this._synced = false;
    _this._original_triggerAttack = _this.triggerAttack;
    _this._original_triggerRelease = _this.triggerRelease;
    var options = optionsFromArguments(Instrument.getDefaults(), arguments);
    _this._volume = _this.output = new Volume({
      context: _this.context,
      volume: options.volume
    });
    _this.volume = _this._volume.volume;
    readOnly(_assertThisInitialized(_this), "volume");
    return _this;
  }

  _createClass(Instrument, [{
    key: "sync",
    value:
    /**
     * Sync the instrument to the Transport. All subsequent calls of
     * [[triggerAttack]] and [[triggerRelease]] will be scheduled along the transport.
     * @example
     * const fmSynth = new Tone.FMSynth().toDestination();
     * fmSynth.volume.value = -6;
     * fmSynth.sync();
     * // schedule 3 notes when the transport first starts
     * fmSynth.triggerAttackRelease("C4", "8n", 0);
     * fmSynth.triggerAttackRelease("E4", "8n", "8n");
     * fmSynth.triggerAttackRelease("G4", "8n", "4n");
     * // start the transport to hear the notes
     * Tone.Transport.start();
     */
    function sync() {
      if (this._syncState()) {
        this._syncMethod("triggerAttack", 1);

        this._syncMethod("triggerRelease", 0);
      }

      return this;
    }
    /**
     * set _sync
     */

  }, {
    key: "_syncState",
    value: function _syncState() {
      var changed = false;

      if (!this._synced) {
        this._synced = true;
        changed = true;
      }

      return changed;
    }
    /**
     * Wrap the given method so that it can be synchronized
     * @param method Which method to wrap and sync
     * @param  timePosition What position the time argument appears in
     */

  }, {
    key: "_syncMethod",
    value: function _syncMethod(method, timePosition) {
      var _this2 = this;

      var originalMethod = this["_original_" + method] = this[method];

      this[method] = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var time = args[timePosition];

        var id = _this2.context.transport.schedule(function (t) {
          args[timePosition] = t;
          originalMethod.apply(_this2, args);
        }, time);

        _this2._scheduledEvents.push(id);
      };
    }
    /**
     * Unsync the instrument from the Transport
     */

  }, {
    key: "unsync",
    value: function unsync() {
      var _this3 = this;

      this._scheduledEvents.forEach(function (id) {
        return _this3.context.transport.clear(id);
      });

      this._scheduledEvents = [];

      if (this._synced) {
        this._synced = false;
        this.triggerAttack = this._original_triggerAttack;
        this.triggerRelease = this._original_triggerRelease;
      }

      return this;
    }
    /**
     * Trigger the attack and then the release after the duration.
     * @param  note     The note to trigger.
     * @param  duration How long the note should be held for before
     *                         triggering the release. This value must be greater than 0.
     * @param time  When the note should be triggered.
     * @param  velocity The velocity the note should be triggered at.
     * @example
     * const synth = new Tone.Synth().toDestination();
     * // trigger "C4" for the duration of an 8th note
     * synth.triggerAttackRelease("C4", "8n");
     */

  }, {
    key: "triggerAttackRelease",
    value: function triggerAttackRelease(note, duration, time, velocity) {
      var computedTime = this.toSeconds(time);
      var computedDuration = this.toSeconds(duration);
      this.triggerAttack(note, computedTime, velocity);
      this.triggerRelease(computedTime + computedDuration);
      return this;
    }
    /**
     * clean up
     * @returns {Instrument} this
     */

  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Instrument.prototype), "dispose", this).call(this);

      this._volume.dispose();

      this.unsync();
      this._scheduledEvents = [];
      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(ToneAudioNode.getDefaults(), {
        volume: 0
      });
    }
  }]);

  return Instrument;
}(ToneAudioNode);